const videoEmbed = [
    {
        selector: '[data-wistia-snippet]',
        path: { filename: 'videoEmbed' },
    },
];

export { videoEmbed };
